// Checkbox for dossier select
// Delegate from document so the handler is wired exactly once at module
// evaluation, independent of `turbo:load` timing — turbo-frame swaps and
// Vue-rendered contexts (e.g. notebook modals) don't re-fire turbo:load,
// so a body-delegation gated on it would silently miss those clicks.
$(document).on('click', '.checkbox-child-select', function() {
  $(this).toggleClass('checkbox-child-select--active');
  const $checkbox = $(this).find('.checkbox-child-select__hidden-checkbox');
  $checkbox.prop('checked', !$checkbox.prop('checked'));
});
